import React from 'react'
import {SliderComponent} from '../slider'

export class Home extends React.Component {
    render(){
        return(
            <section className="section" id="page-content">
            <SliderComponent></SliderComponent>
            </section>
        );
    }
}